export class Country {
  countryId!: number;
  countryName!: string;
  constructor(source: Partial<Country>) {
    Object.assign(this, source);
  }
}
